import { Link } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";
import { hotArticles, latestArticles } from "@/utils/news";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import HotList from "@/pages/home/components/HotList";
import ArticleCard from "@/components/feature/ArticleCard";

export default function Home() {
  usePageMeta({
    title: "51吃瓜网站 - 热点新闻与娱乐八卦资讯平台",
    description:
      "51吃瓜网站为您提供最新的热点新闻、娱乐八卦和社会资讯，涵盖明星动态、网络热议事件等内容，轻松了解每日新鲜吃瓜信息。",
    keywords: "51吃瓜网站,热点新闻,娱乐八卦,明星动态,社会资讯,网络热议,最新消息,吃瓜资讯",
  });

  const heroItems = latestArticles(5);
  const latestList = latestArticles(8);
  const hotList = hotArticles(6);

  return (
    <div className="bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-6 md:px-6 md:py-8">
        <HeroCarousel items={heroItems} />

        <section className="mt-10">
          <div className="mb-5 flex items-end justify-between">
            <div>
              <h1 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                51吃瓜网站
              </h1>
              <p className="mt-1.5 text-sm text-foreground-600">
                每日新鲜吃瓜资讯，明星动态、网络热议一网打尽
              </p>
            </div>
            <span className="hidden items-center gap-1.5 text-xs text-foreground-400 md:flex">
              <i className="ri-refresh-line"></i> 每 10 分钟更新
            </span>
          </div>
          <CategoryGrid />
        </section>

        <section className="mt-12">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_340px]">
            <div>
              <div className="mb-5 flex items-center justify-between">
                <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
                  <i className="ri-newspaper-line text-primary-500"></i>
                  最新资讯
                </h2>
                <Link
                  to="/category/hot"
                  className="cursor-pointer whitespace-nowrap text-sm text-accent-600 transition-colors hover:text-accent-700"
                >
                  查看更多
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
              <div className="flex flex-col gap-4">
                {latestList.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>

            <div className="flex flex-col gap-6">
              <HotList items={hotList} />
              <div className="rounded-lg border border-background-200 bg-secondary-50 p-5">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-hashtag text-accent-500"></i>
                  热门标签
                </h3>
                <div className="mt-4 flex flex-wrap gap-2">
                  {[
                    "明星动态",
                    "新剧",
                    "演唱会",
                    "网络热议",
                    "表情包",
                    "夜市",
                    "旅游",
                    "垃圾分类",
                    "图书馆",
                    "穿搭",
                  ].map((tag) => (
                    <Link
                      key={tag}
                      to={`/search?q=${encodeURIComponent(tag)}`}
                      className="cursor-pointer rounded-full bg-background-50 px-3 py-1 text-xs text-secondary-900 transition-colors hover:bg-accent-100 hover:text-accent-800"
                    >
                      #{tag}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}